export enum MetricType {
  retentionRate = "retention_rate",
  churnRate = "churn_rate",
  dau = "dau",
  mau = "mau",
  dailySessionsPerDau = "daily_sessions_per_dau",
  stickiness = "stickiness",
  demandLevel = "demand_level",
  viewsPerAd = "views_per_ad",
  totalViews = "total_views",
  adViews = "ad_views",
  sellers = "sellers",
  contactAttempts = "contact_attempts",
  usersWithAds = "users_with_ads",
  usersWithMessages = "users_with_messages",
  screenTransitions = "screen_transitions",
  transitionSource = "transition_source",
  timeInMenu = "time_in_menu",
  activityTime = "activity_time",
  buttonClicks = "button_clicks",
  searchQueries = "search_queries",
  phoneMasks = "phone_masks",
  ipGeoposition = "ip_geoposition",
  geopositionComposite = "geoposition_composite",
  callButtonClicks = "call_button_clicks",
  popularFilters = "popular_filters",
  adDemandRate = "ad_demand_rate",
  activeAdsCount = "active_ads_count",
}

export function getMetricTitle(metric: MetricType): string {
  switch (metric) {
    case MetricType.retentionRate:
      return "Retention Rate";
    case MetricType.churnRate:
      return "Churn Rate";
    case MetricType.dau:
      return "DAU";
    case MetricType.mau:
      return "MAU";
    case MetricType.dailySessionsPerDau:
      return "Daily Sessions per DAU";
    case MetricType.stickiness:
      return "Stickiness (DAU/MAU)";
    case MetricType.demandLevel:
      return "Уровень спроса";
    case MetricType.viewsPerAd:
      return "Просмотров на объявление";
    case MetricType.totalViews:
      return "Всего просмотров";
    case MetricType.adViews:
      return "Просмотры объявлений";
    case MetricType.sellers:
      return "Продавцы";
    case MetricType.contactAttempts:
      return "Контакты";
    case MetricType.usersWithAds:
      return "Пользователи с объявлениями";
    case MetricType.usersWithMessages:
      return "Пользователи с сообщениями";
    case MetricType.screenTransitions:
      return "Цепочка переходов";
    case MetricType.transitionSource:
      return "Откуда был переход";
    case MetricType.timeInMenu:
      return "Время в меню";
    case MetricType.activityTime:
      return "Активность в приложении (время)";
    case MetricType.buttonClicks:
      return "Клики на главном экране";
    case MetricType.searchQueries:
      return "Поисковые запросы";
    case MetricType.phoneMasks:
      return "Маски телефонов";
    case MetricType.ipGeoposition:
      return "IP / Геопозиция";
    case MetricType.geopositionComposite:
      return "Геопозиция (сборная)";
    case MetricType.callButtonClicks:
      return "Клики на кнопку «Позвонить»";
    case MetricType.popularFilters:
      return "Популярные фильтры";
    case MetricType.adDemandRate:
      return "Уровень спроса";
    case MetricType.activeAdsCount:
      return "Количество активных объявлений";
    default:
      return "Неизвестная метрика";
  }
}
